import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                close: 'close'
            }
        }

        this.closeBind = (e) => {
            if (e.key === "Escape") {
               this.close();
           }
       }

       document.addEventListener('keyup', this.closeBind)
    }

    init() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        if(urlParams.has('customer_posted')) {
            this.show();
        }
    }

    show() {
        html.classList.add('has-newsletter-alert')
    }

    close() {
        html.classList.remove('has-newsletter-alert')
    }

    destroy() {
        super.destroy()
        this.close()
        document.removeEventListener('keyup', this.closeBind)
    }
}
